module.exports = __webpack_public_path__ + "img/redirect-to-any.a8b58f54.svg";